// eslint-disable-next-line import/prefer-default-export
export const ENV_TYPES = {
  TEST: "TEST",
  PRODUCTION: "PRODUCTION",
};

export const MESSAGE_TYPE = {
  SUCCESS: "Success",
  FAILURE: "Fail",
  INFORMATION: "Information",
  INTERNAL_ERROR: "Internal Error",
  LOADING: "Loading",
};

export const LOG_LEVEL = {
  INFO: { name: "INFO", value: 1 },
  WARN: { name: "WARN", value: 2 },
  ERROR: { name: "ERROR", value: 3 },
};

export const INACTIVITY_EXCEPTION_URLS = {
  AUTH_BULK_RESOURCE: "authorization/bulk-allowed-resources",
  AUTH_ALLOWED_RESOURCE: "authorization/allowed-resources",
};

export const API_RESOURCE_URLS = {
  LOG_ERROR: "flowhouse/logs/v2",
  AUTH_BULK_RESOURCE: "authorization/bulk-allowed-resources",

    
};
export const APPLICATION_NAME = "IRIS PORTAL";

export const EXPORT_TYPE = {
  PDF: "pdf",
  EXCEL: "excel",
};

export const USER_OPERATIONS = {
  POST: "POST",
  GET: "GET",
};

export const USER_TYPE = {
  APPROVER: "approver",
  PERFORMER: "performer",
  RTA: "rta",
  ADMIN:"admin",
  AUDITOR:'auditor'
};

export const ROUTES = {
  ROOT: "/",
  DASHBOARD: "/dashboard",
  QUESTIONNAIRE: "/questionnaire",
  IEPFReport:'/IEPFReport',
  IEPFReportDetails: "/IEPFReport/:queryTicketId",

  // Approver Routes
  APPROVER_APPROVED: "/approver/approved",
  APPROVER_PENDING: "/approver/pending",
  APPROVER_REJECTED: "/approver/rejected",
  APPROVER_CLOSE: "/approver/close",

  // RTA Pages ROUTES
  TICKET_STATUS:"/ticket-status",
  RTA_RECTIFY: "/rta-rectify",

  // Performer Routes
  PERFORMER_APPROVED: "/performer/approved",
  PERFORMER_IN_APPROVAL: "/performer/in-approval",
  PERFORMER_PENDING: "/performer/pending",
  PERFORMER_REJECTED: "/performer/rejected",
  PERFORMER_COMPANY: "/performer/company",
  PERFORMER_SHAREHOLDER: "/performer/shareholder",
  PERFORMER_EL_PROCESS: "/performer/elProcess",
  PERFORMER_E_VERIFICATION: "/performer/everification",
  PERFORMER_SRN: "/performer/srn",
  PERFORMER_PENDING_SRN: "/performer/pending-srn",
  GOTOQUESTIONNAIRE: (ticketId,ticketCode, mode) => `/questionnaire?ticketId=${ticketId}&ticketCode=${ticketCode}&mode=${mode}`,
};
export const MESSAGE = {
  FORBIDDEN_ACCESS: "Forbidden access.",
  PERMISSION_DENIED: "You do not have permission to access.",
};
export const SCREEN_REFRESH_INTERVAL_TIME_MS = 30000;

export const NOTIFICATION_TYPE = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  INFO: "INFO",
  WARNING: "WARNING",
  NOTIFICATION: "NOTIFICATION",
};

export const NOTIFICATION_ACTIONS = {
  CLOSE: "Close",
  INFO: "Info",
  RETRY: "Retry",
  REFRESH: "Refresh",
};

export const BUTTONS = {
  CUSTOMISE_TABLE: "Customise table",
};

export const commonTextFieldProps = {
  variant: "outlined",
  fullWidth: true,
  required: true,
  InputLabelProps: {
    shrink: true,
  },
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export const ALLOWED_FILE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
];

export const STEPS = ["Submit Ticket Details", "Upload Documents"];

export const HINT_FORM_TEXT = {
  companyName: "Tata Motors Ltd.",
  shareholderName: "Rajesh Kumar",
  claimantName: "Rajesh Kumar",
  beneficiaryAccount: "1201230004567890",
  securityType: "Equity",
  numberOfShares: "100",
  shareFaceValue: "10",
  folioId: "FOL12345687986543989",
  dematId: "IN30123456789012",
  SRN: "I9876543768",
  transferDate: "2023-07-15",
  unclaimedSuspenseAccount: "No",
  iepfRules: "Yes",
  signatureMismatch: "No",
  securityMismatch: "No",
  litigationPending: "Yes",
  status: "Approved",
  caseType: ["Indian Resident - Share certf", "Transmission"],
  remark: "Awaiting legal clearance for transmission",
  dividendEntries: [
    {
      financialYear: "2018-2019",
      paymentDate: "2019-09-05",
      warrantNo: "WRT456789",
      amount: "250.00",
    },
    {
      financialYear: "2019-2020",
      paymentDate: "2020-08-20",
      warrantNo: "WRT567890",
      amount: "300.00",
    },
  ],
};